// extracted by mini-css-extract-plugin
export default {"provider-card-openings":"EEWkQaabg5PFAI0BL9zK9","provider-card-openings__availibility":"_2nkJkYxfoe9-IrL5xBBqSh","provider-card-openings__next-opening":"_2xYnFv9QVK3GDtHznpjo04"};